import { color } from "framer-motion"
import "../../../resources/fonts/fonts.css"

    export const DialogStyles = {
        //set color to white if dark mode is on or else set to black
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["SlimIMS, Century "].join(",")
    }
    export const MainGridStyles = {
        width: "98vw"
    }
    export const GridMarginStyles = {
        marginTop: "10px"
    }
    export const RowPaperStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginLeft: "10px",
        marginBottom: "15px"
    }
    export const ColumnBoxStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start"
    }

    export const ButtonPaperStyles = {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        maxHeight: "80px",
        alignItems: "center",
        overflowX: "auto",
        "&::-webkit-scrollbar": {
            height: "10px"
        },
        "&::-webkit-scrollbar-track": {
            boxShadow: "inset 0 0 2px rgba(0,0,0,0.00)",
            webkitBoxShadow: "inset 0 0 10px rgba(0,0,0,0.00)"
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "grey",
            height: "10px"
        }
    }
    export const ButtonContainerPaperStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        maxHeight: "80px",
        alignItems: "center",
        marginLeft: "10px",
        overflow: "hidden",
        marginBottom: "15px"
    }
    export const ButtonGridStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        direction: "row",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        wrap: "nowrap"
    }
    export const StackStyles = {
        marginLeft: "10px",
        paddingBottom: "10px"
    }
    export const CharacteristicStackStyles = {
        marginLeft: "10px",
        marginBottom: "15px"
    }
    export const ItemPaperStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    }
    export const VerificationPaperStyles = {
        height: "100%",
        marginLeft: "10px",
        marginRight: "10px",
        marginBottom: "10px"
    }
    export const ItemSelectorStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["SlimIMS, Century "].join(","),
        maxWidth: "98%",
        marginRight: "5px",
        marginLeft: "5px",
        marginTop: "5px",
        marginBottom: "5px"
    }
    export const ItemAutoCompleteStyles = {
        marginRight: (theme) => theme.spacing(2)
    }
    export const CloneItemSelectorStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["SlimIMS, Century "].join(","),
        minWidth: "150px",
        marginRight: "5px",
        marginLeft: "5px",
        marginTop: "5px",
        marginBottom: "5px"
    }
    export const ItemGridItemStyles = {
        marginRight: "5px"
    }
    export const PrimarySelectorStyles = {
        minWidth: "130px",
        marginLeft: "5px",
        marginRight: "5px",
        marginTop: "5px",
        marginBottom: "5px"
    }
    export const VerificationSelectorStyles = {
        minWidth: "130px",
        marginLeft: "5px",
        marginRight: "5px",
        marginBottom: "5px"
    }
    export const PPAPSelectorStyles = {
        minWidth: "130px",
        [(theme) => theme.breakpoints.down("sm")]: {
            align: "right "
        }
    }
    export const ButtonStyles = {
        fontFamily: ["SlimIMS, Century "].join(","),
        fontSize: "14px",
        border: "1px solid",
        marginLeft: "5px",
        marginRight: "5px",
        marginTop: "5px",
        marginBottom: "5px",
        textTransform: "none",
        backgroundColor: '#e0e0e0', 
        color: 'black',
        backgroundImage: "none",
        "&:hover": {
            backgroundColor: '#d5d5d5', 
            boxShadow: '0 2 4 -1px rgba(0,0,0,0.2), 0 4 5 0 rgba(0,0,0,0.14), 0 1 10 0 rgba(0,0,0,0.12)' ,
        }
    }
    export const ButtonNoBorderStyles = {
        color: "white",
        fontFamily: ["SlimIMS, Century "].join(","),
        marginLeft: "5px",
        marginRight: "5px",
        textTransform: "none"
    }
    export const AddCharacteristicButtonStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["SlimIMS, Century "].join(","),
        marginLeft: "5px",
        marginRight: "5px",
        marginTop: "5px",
        marginBottom: "5px",
        textTransform: "none"
    }
    export const ArchiveButtonStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["SlimIMS, Century "].join(","),
        fontSize: "14px",
        fontWeight: "bold",
        minWidth: "84px",
        border: "1px solid",
        marginLeft: "5px",
        marginRight: "5px",
        marginTop: "10px",
        marginBottom: "5px",
        textTransform: "none",
        backgroundColor: "#CC1A21",
        borderColor: "#CC1A21"
    }
    export const PrintButtonStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["SlimIMS, Century "].join(","),
        fontSize: "14px",
        fontWeight: "bold",
        minWidth: "max-content",
        border: "1px solid",
        marginLeft: "5px",
        marginRight: "5px",
        marginTop: "10px",
        marginBottom: "5px",
        textTransform: "none"
    }
    export const PrintAllButtonStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["SlimIMS, Century "].join(","),
        fontSize: "14px",
        fontWeight: "bold",
        minWidth: "max-content",
        flexShrink: 1,
        border: "1px solid",
        marginLeft: "5px",
        marginRight: "5px",
        marginTop: "10px",
        marginBottom: "5px",
        whiteSpace: "nowrap",
        textTransform: "none",
        paddingLeft: '18px',
        paddingRight: '18px'
    }
    export const CloneButtonStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["SlimIMS, Century "].join(","),
        fontSize: "14px",
        fontWeight: "bold",
        minWidth: "max-content",
        border: "1px solid",
        marginLeft: "5px",
        marginRight: "5px",
        marginTop: "10px",
        marginBottom: "5px",
        textTransform: "none",
        paddingLeft: '18px',
        paddingRight: '18px'
    }
    export const HelpButtonStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["SlimIMS, Century "].join(","),
        fontSize: "14px",
        fontWeight: "bold",
        minWidth: "max-content",
        border: "1px solid",
        marginLeft: "5px",
        marginRight: "5px",
        marginTop: "10px",
        marginBottom: "5px",
        textTransform: "none",
        backgroundColor: "#DF7A00",
        borderColor: "#DF7A00"
    }
    export const GetOpsButtonStyles = {
        fontFamily: ["SlimIMS, Century "].join(","),
        fontSize: "14px",
        border: "1px solid",
        marginRight: "5px",
        marginTop: "5px",
        marginBottom: "5px",
        textTransform: "none"
    }
    export const RevisionSelectorStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["SlimIMS, Century "].join(","),
        maxWidth: "98%",
        marginLeft: "5px",
        marginRight: "5px",
        marginTop: "5px",
        marginBottom: "5px"
    }
    export const RevisionAutoCompleteStyles = {
        marginRight: (theme) => theme.spacing(2)
    }
    export const CloneRevisionSelectorStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["SlimIMS, Century "].join(","),
        maxWidth: "100px",
        marginLeft: "5px",
        marginRight: "5px",
        marginTop: "5px",
        marginBottom: "5px"
    }
    export const CurrentRevisionStyles = {
        fontSize: "20px ",
        paddingLeft: "10px"
    }
    export const MOSelectorStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["SlimIMS, Century "].join(","),
        marginLeft: "5px",
        marginRight: "5px",
        width: "180px",
        marginTop: "5px",
        marginBottom: "5px"
    }
    export const WorkcenterSelectorStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["SlimIMS, Century "].join(","),
        marginLeft: "5px",
        marginRight: "5px",
        width: "180px",
        marginTop: "5px",
        marginBottom: "5px"
    }
    export const GridContentStyles = {
        paddingLeft: "5px",
        paddingRight: "5px",
        paddingTop: "5px",
        paddingBottom: "5px",
        textOverflow: "clip",
        fontFamily: ["SlimIMS, Century "].join(","),
        fontSize: "16px"
    }
    export const GridContentRightStyles = {
        paddingLeft: "5px",
        paddingRight: "5px",
        paddingTop: "5px",
        paddingBottom: "5px",
        [(theme) =>theme.breakpoints.down("sm")]: {
            align: "right"
        },
        fontFamily: ["SlimIMS, Century "].join(","),
        fontSize: "16px"
    }
    export const ContainerBoxStyles = {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
    }
    export const DragDividerStyles = {
        marginTop: "5px",
        marginBottom: "5px"
    }
    export const ResetRoutingStyles = {}
    export const TableCellStyles = {
        fontFamily: [" SlimIMS, Century "].join(","),
        fontSize: "14px ",
        margingTop: "1px ",
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingLeft: '4px',
        paddingRight: '4px',
    }
    export const TableCellMarginStyles = {
        fontFamily: ["SlimIMS, Century "].join(","),
        fontSize: "14px ",
        margin: "2px",
        '& .MuiInputBase-root::before': {
            borderBottom: 'none',
        },
        '& .MuiInputBase-root::after': {
            borderBottom: 'none',
        },
        '& .MuiInputBase-root.Mui-disabled::before': {
            borderBottom: 'none',
        }
    }
    export const RowBorderStyles = {
        borderBottom: "1px solid",
        borderRight: "1px solid",
        borderLeft: "1px solid"
    }
    export const RowBorderLastStyles = {
        borderTop: "1px solid",
        borderRight: "1px solid",
        borderLeft: "1px solid",
        borderBottom: "1px solid"
    }
    export const CharacteristicPaperStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        maxHeight: "50vh",
        alignItems: "center",
        overflow: "auto",
        "&::-webkit-scrollbar": {
            width: "10px"
        },
        "&::-webkit-scrollbar-track": {
            boxShadow: "inset 0 0 5px rgba(0,0,0,0.00)",
            webkitBoxShadow: "inset 0 0 10px rgba(0,0,0,0.00)"
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "grey",
            width: "10px"
        }
    }
    export const CharacteristicPaperAltStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        maxHeight: "400px",
        alignItems: "center",
        overflow: "auto",
        "&::-webkit-scrollbar": {
            width: "10px"
        },
        "&::-webkit-scrollbar-track": {
            boxShadow: "inset 0 0 5px rgba(0,0,0,0.00)",
            webkitBoxShadow: "inset 0 0 10px rgba(0,0,0,0.00)"
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "grey",
            width: "10px"
        }
    }
    export const LeftGridStyles = {
        alignContent: "flex-start",
        overflow: "hidden",
        overflowX: "hidden"
    }
    export const CharacteristicContainerPaperStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        maxHeight: "60vh",
        alignItems: "center",
        marginLeft: "10px",
        marginBottom: "15px",
        overflowX: "hidden"
    }
    export const CharacteristicGridStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        wrap: "nowrap",
        width: "100%"
    }
    export const ColumnHeaderGridStyles = {
        marginLeft: "5px"
    }
    export const ColumnHeaderStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontSize: "14px",
        overflow: "hidden ",
        textOverflow: "ellipsis",
        fontWeight: "bold"
    }
    export const CellDividerStyles = {
        marginRight: "-1px"
    }
    export const CharacteristicDialogStyles = {
        fontFamily: ["SlimIMS, Century "].join(",")
    }
    export const FullWidthStyles = {
        width: "100%"
    }
    export const FavoritesTabStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        display: "flex",
        height: "100%",
        flexDirection: "column",
        justifyContent: "space-between",
        marginLeft: "10px",
        marginBottom: "5px",
        alignItems: "center",
        overflow: "auto",
        "&::-webkit-scrollbar": {
            width: "10px"
        },
        "&::-webkit-scrollbar-track": {
            boxShadow: "inset 0 0 5px rgba(0,0,0,0.00)",
            webkitBoxShadow: "inset 0 0 10px rgba(0,0,0,0.00)"
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "grey",
            width: "10px"
        }
    }
    export const ControlTabStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        display: "flex",
        overflow: "hidden",
        flexDirection: "row",
        justifyContent: "space-between",
        marginLeft: "10px",
        marginBottom: "10px",
        alignItems: "center",
        overflowX: "auto",
        "&::-webkit-scrollbar": {
            height: "10px"
        },
        "&::-webkit-scrollbar-track": {
            boxShadow: "inset 0 0 2px rgba(0,0,0,0.00)",
            webkitBoxShadow: "inset 0 0 10px rgba(0,0,0,0.00)"
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "grey",
            height: "10px"
        }
    }
    export const ControlGridStyles = {}
    export const CharacteristicBoxStyles = {
        fontFamily: ["SlimIMS, Century "].join(","),
        minWidth: "350px",
        margingTop: "1px "
    }
    export const ToFromStyles = {
        marginBottom: "15px"
    }
    export const CloneGridStyles = {
        paddingLeft: "5px"
    }
    export const CloneDialogStyles = {
        //set color to white if dark mode is on or else set to black
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["SlimIMS, Century "].join(",")
    }
    export const EmailButtonStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["SlimIMS, Century "].join(","),
        fontSize: "14px",
        fontWeight: "bold",
        border: "1px solid",
        minWidth: "136px",
        marginLeft: "5px",
        marginRight: "5px",
        marginTop: "10px",
        marginBottom: "5px",
        textTransform: "none"
    }
    export const EditButtonStyles = {
        fontSize: "16px ",
        marginLeft: "2px",
        marginTop: "-6px"
    }
    export const CloneContainerStyles = {
        width: "600px"
    }
    export const buttonProgressStyles = {
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12
    }
